import React from 'react'
import { HashRouter as Router, Switch, Route, Redirect, useLocation } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import { StoreProvider, useStoreActions, useStoreState } from 'easy-peasy'
import { useAsync } from 'react-use'

import PageLogin from 'pages/Login'

import PageMyIncident from 'pages/MyIncident'
import PageMyIncidentSetUp from 'pages/MyIncidentSetup'
import PageTeamIncident from 'pages/TeamIncident'
import PageMyTask from 'pages/MyTask'

import PageReportType from 'pages/ReportType'
import PageGroupAttribute from 'pages/GroupAttribute'
import PageReportAttribute from 'pages/ReportAttribute'
import PageReportAttributeDetail from 'pages/ReportAttributeDetail'
import PageDictionary from 'pages/Dictionary'
import PageDictionaryDetail from 'pages/DictionaryDetail'
import PageReportHeaderAttribute from 'pages/ReportHeaderAttribute'
import PageReportHeaderAttributeSetup from 'pages/ReportHeaderAttributeSetup'
import PageRiskLevelSetup from 'pages/RiskLevelSetup'

import PageOrganization from 'pages/Organization'
import PageProfile from 'pages/Profile'
import PageUser from 'pages/User'

import PageMonthlyDashboard from 'pages/MonthlyDashboard'
import PageMonthlyReport from 'pages/MonthlyReport'
import PageMonthlyReview from 'pages/MonthlyReview'
import PageEventTracking from 'pages/EventTracking'

import PageNotFound from 'pages/NotFound'

import LayoutMain from 'layouts/Main'

import { defaultValidateMessages } from 'configs/validateMessages'

import store from './store'

import './locales/i18n'

import './App.less'

const LayoutAuthRouter = () => {
  return (
    <Switch>
      {/* {!localStorage.getItem('user') && (
        <Route exact path="/">
          <PageLogin />
        </Route>
      )}  */}
      <Route>
        <PageLogin />
      </Route>
    </Switch>
  )
}

const LayoutMainRouter = () => {
  const { pathname } = useLocation()

  const getGroupAttributes = useStoreActions((actions) => actions.filter.getGroupAttributes)
  const getDataTypes = useStoreActions((actions) => actions.filter.getDataTypes)
  const getDictionaries = useStoreActions((actions) => actions.filter.getDictionaries)
  const getDays = useStoreActions((actions) => actions.filter.getDays)
  const getReportTypeAttributes = useStoreActions(
    (actions) => actions.filter.getReportTypeAttributes
  )
  const getReportStatuses = useStoreActions((actions) => actions.filter.getReportStatuses)
  const getReportTypes = useStoreActions((actions) => actions.filter.getReportTypes)
  const getRiskLevels = useStoreActions((actions) => actions.filter.getRiskLevels)
  const getImpactTypes = useStoreActions((actions) => actions.filter.getImpactTypes)
  const getFilterOrganizations = useStoreActions((actions) => actions.filter.getOrganizations)

  useAsync(async () => {
    Promise.all([
      getGroupAttributes(),
      getDataTypes(),
      getDictionaries(),
      getDays(),
      getReportTypeAttributes(),
      getReportStatuses(),
      getReportTypes(),
      getRiskLevels(),
      getImpactTypes(),
      getFilterOrganizations(),
    ])
  }, [])
  const menu = JSON.parse(localStorage.getItem('menu')) || []

  return (
    localStorage.getItem('user') && (
      <LayoutMain>
        <Switch>
          <Redirect from='/:url*(/+)' to={pathname.slice(0, -1)} />
          {menu.find((m) => m?.menu_name === 'Incident Mangement') ? (
            <Route exact path='/incident-management/my-incident'>
              <PageMyIncident />
            </Route>
          ) : (
            <Route exact path='/incident-management/my-incident'>
              <PageNotFound />
            </Route>
          )}
          {menu.find((m) => m?.menu_name === 'Incident Mangement') ? (
            <Route exact path='/incident-report/:id'>
              <PageMyIncidentSetUp />
            </Route>
          ) : (
            <Route exact path='/incident-report/:id'>
              <PageNotFound />
            </Route>
          )}
          {menu.find((m) => m?.menu_name === 'Incident Mangement') ? (
            <Route exact path='/incident-report/:id/:hederId'>
              <PageMyIncidentSetUp />
            </Route>
          ) : (
            <Route exact path='/incident-report/:id/:hederId'>
              <PageNotFound />
            </Route>
          )}
          {menu.find((m) => m?.menu_name === 'Incident Mangement') ? (
            <Route exact path='/incident-management/team-incident'>
              <PageTeamIncident />
            </Route>
          ) : (
            <Route exact path='/incident-management/team-incident'>
              <PageNotFound />
            </Route>
          )}
          {menu.find((m) => m?.menu_name === 'Incident Mangement') ? (
            <Route exact path='/incident-management/my-task'>
              <PageMyTask />
            </Route>
          ) : (
            <Route exact path='/incident-management/my-task'>
              <PageNotFound />
            </Route>
          )}

          {menu.find((m) => m?.menu_name === 'Report Setup') ? (
            <Route exact path='/report-setup/report-type'>
              <PageReportType />
            </Route>
          ) : (
            <Route exact path='/report-setup/report-type'>
              <PageNotFound />
            </Route>
          )}
          {menu.find((m) => m?.menu_name === 'Report Setup') ? (
            <Route exact path='/report-setup/group-attribute'>
              <PageGroupAttribute />
            </Route>
          ) : (
            <Route exact path='/report-setup/group-attribute'>
              <PageNotFound />
            </Route>
          )}
          {menu.find((m) => m?.menu_name === 'Report Setup') ? (
            <Route exact path='/report-setup/report-attribute'>
              <PageReportAttribute />
            </Route>
          ) : (
            <Route exact path='/report-setup/report-attribute'>
              <PageNotFound />
            </Route>
          )}
          {menu.find((m) => m?.menu_name === 'Report Setup') ? (
            <Route exact path='/report-setup/report-attribute/:id'>
              <PageReportAttributeDetail />
            </Route>
          ) : (
            <Route exact path='/report-setup/report-attribute/:id'>
              <PageNotFound />
            </Route>
          )}
          {menu.find((m) => m?.menu_name === 'Report Setup') ? (
            <Route exact path='/report-setup/dictionary'>
              <PageDictionary />
            </Route>
          ) : (
            <Route exact path='/report-setup/dictionary'>
              <PageNotFound />
            </Route>
          )}
          {menu.find((m) => m?.menu_name === 'Report Setup') ? (
            <Route exact path='/report-setup/dictionary/:id'>
              <PageDictionaryDetail />
            </Route>
          ) : (
            <Route exact path='/report-setup/dictionary/:id'>
              <PageNotFound />
            </Route>
          )}
          {menu.find((m) => m?.menu_name === 'Report Setup') ? (
            <Route exact path='/report-setup/report-header-attribute'>
              <PageReportHeaderAttribute />
            </Route>
          ) : (
            <Route exact path='/report-setup/report-header-attribute'>
              <PageNotFound />
            </Route>
          )}
          {menu.find((m) => m?.menu_name === 'Report Setup') ? (
            <Route exact path='/report-setup/report-header-attribute/:id'>
              <PageReportHeaderAttributeSetup />
            </Route>
          ) : (
            <Route exact path='/report-setup/report-header-attribute/:id'>
              <PageNotFound />
            </Route>
          )}
          {menu.find((m) => m?.menu_name === 'Report Setup') ? (
            <Route exact path='/report-setup/risk-level-setup'>
              <PageRiskLevelSetup />
            </Route>
          ) : (
            <Route exact path='/report-setup/risk-level-setup'>
              <PageNotFound />
            </Route>
          )}

          {menu.find((m) => m?.menu_name === 'Settings') ? (
            <Route exact path='/setting/organization'>
              <PageOrganization />
            </Route>
          ) : (
            <Route exact path='/setting/organization'>
              <PageNotFound />
            </Route>
          )}
          {menu.find((m) => m?.menu_name === 'Settings') ? (
            <Route exact path='/setting/profile'>
              <PageProfile />
            </Route>
          ) : (
            <Route exact path='/setting/profile'>
              <PageNotFound />
            </Route>
          )}
          {menu.find((m) => m?.menu_name === 'Settings') ? (
            <Route exact path='/setting/user'>
              <PageUser />
            </Route>
          ) : (
            <Route exact path='/setting/user'>
              <PageNotFound />
            </Route>
          )}

          {menu.find((m) => m?.menu_name === 'Dashboard') ? (
            <Route exact path='/report/monthly-dashboard'>
              <PageMonthlyDashboard />
            </Route>
          ) : (
            <Route exact path='/report/monthly-dashboard'>
              <PageNotFound />
            </Route>
          )}
          {menu.find((m) => m?.menu_name === 'Dashboard') ? (
            <Route exact path='/report/monthly-report'>
              <PageMonthlyReport />
            </Route>
          ) : (
            <Route exact path='/report/monthly-report'>
              <PageNotFound />
            </Route>
          )}
          {menu.find((m) => m?.menu_name === 'Dashboard') ? (
            <Route exact path='/report/monthly-review'>
              <PageMonthlyReview />
            </Route>
          ) : (
            <Route exact path='/report/monthly-review'>
              <PageNotFound />
            </Route>
          )}
          {menu.find((m) => m?.menu_name === 'Dashboard') ? (
            <Route exact path='/report/event-tracking/:report_code'>
              <PageEventTracking />
            </Route>
          ) : (
            <Route exact path='/report/event-tracking/:report_code'>
              <PageNotFound />
            </Route>
          )}
          {menu.find((m) => m?.menu_name === 'Dashboard') ? (
            <Route exact path='/report/event-tracking'>
              <PageEventTracking />
            </Route>
          ) : (
            <Route exact path='/report/event-tracking'>
              <PageNotFound />
            </Route>
          )}

          <Route exact path='/'>
            <PageMyIncident />
          </Route>
        </Switch>
      </LayoutMain>
    )
  )
}

const AfterStoreProvider = () => {
  const isLogin = useStoreState((state) => state.auth.isLogin)
  const setLogin = useStoreActions((action) => action.auth.setLogin)
  const isLog = localStorage.getItem('isLogin')
  const checkMenu = localStorage.getItem('menu') || null
  console.log('-=-=-=-=-=', checkMenu)

  useAsync(async () => {
    const user = localStorage.getItem('user')
    if (user) {
      setLogin(true)
    }
  }, [])
  console.log('isLogin', isLogin)
  return (
    <ConfigProvider form={{ validateMessages: defaultValidateMessages }}>
      <Router basename={process.env.REACT_APP_BASENAME}>
        {isLogin && isLog === 'true' && checkMenu ? <LayoutMainRouter /> : <LayoutAuthRouter />}
      </Router>
    </ConfigProvider>
  )
}

export default function App () {
  return (
    <StoreProvider store={store}>
      <AfterStoreProvider />
    </StoreProvider>
  )
}
